export enum ReferralType {
  None = 'None',
  PBS = 'PBS',
  ECREF = 'ECREF',
}
